import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import { AuthService } from '../services';

const VerifyEmail: React.FC = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
    const [message, setMessage] = useState('');

    useEffect(() => {
        const verify = async () => {
            if (!token) return;
            
            try {
                // Get email from URL if present
                const params = new URLSearchParams(window.location.search);
                const email = params.get('email');
                
                const response = await AuthService.verifyEmail(token, email || undefined);
                setStatus('success');
                setMessage(response.message);
                // Redirect to login after 3 seconds
                setTimeout(() => navigate('/login'), 3000);
            } catch (error: any) {
                setStatus('error');
                setMessage(error.response?.data?.error || 'Verification failed');
            }
        };

        // Only verify if we're in loading state to prevent double requests
        if (status === 'loading') {
            verify();
        }
    }, [token, navigate, status]);

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                p: 3
            }}
        >
            {status === 'loading' && (
                <>
                    <CircularProgress sx={{ mb: 2 }} />
                    <Typography variant="h6">Verifying your email...</Typography>
                </>
            )}
            {status === 'success' && (
                <Alert severity="success" sx={{ mb: 2 }}>
                    {message}
                    <Typography variant="body2" sx={{ mt: 1 }}>
                        Redirecting to login page...
                    </Typography>
                </Alert>
            )}
            {status === 'error' && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {message}
                </Alert>
            )}
        </Box>
    );
};

export default VerifyEmail;
